@if (searchContainer.searchResult) {
  <ul class="search-result-view-list-selector list-thumbnail">
    @for (art of searchContainer.searchResult.artifacts; track $index) {
      <li
        [ngClass]="{'disabled': art.$$used}"
        class="list-thumbnail__frame-and-shadow"
      >
        <div class="list-thumbnail__item">
          <div class="list-thumbnail__row">
            <div class="list-thumbnail__first-container">
              @if (!searchContainer.selections.singleSelect) {
                <div
                  class="checkbox-underlay"
                  [ngClass]="{'disabled': art.$$used}"
                >
                  <mat-checkbox
                    class="white-bg-in-checkbox"
                    (click)="select(art, $event)"
                    (keydown)="null"
                    [checked]="searchContainer.selections.selected[art.artifact_id]"
                    [disabled]="art.$$used"
                  ></mat-checkbox>
                </div>
              }
              @else {
                <div
                  class="checkbox-underlay"
                  [ngClass]="{'disabled': art.$$used}"
                >
                  <mat-radio-button
                    class="white-bg-in-radio-button"
                    [name]="art.artifact_id"
                    [checked]="selectedItemId === art.artifact_id"
                    (change)="select(art, $event)"
                    [disabled]="art.$$used"
                  ></mat-radio-button>
                </div>
              }

              <div class="thumbnail-url">
                @if (art.thumbnail_id) {
                  <app-thumbnail
                    [item]="art"
                    [stylingClass]="'thumbnail-image thumbnail-fixed-height'"
                  ></app-thumbnail>
                }
                @else {
                  <i class="icon-image imgIcon"></i>
                }
              </div>
            </div>

            <div
              class="list-thumbnail__second-container"
              [ngClass]="{'no-image': !art.$$imageUrl}"
            >
              <app-search-columns-overview-fields
                class="list-thumbnail__object-overview overview-fields__selector"
                [searchObject]="art"
                [viewName]="searchContainer.searchResultViewName"
                [openLinksInTab]="true"
              ></app-search-columns-overview-fields>
            </div>
          </div>
        </div>
      </li>
    }
  </ul>
}
